export default __webpack_public_path__ + "static/media/AA Posters.49d3efa1.png";